export const KEY_GET_DASHBOARD_CONTENTS = 'get.dashboard-contents.call';
export const KEY_GET_CONTENTS_BY_TYPE = 'get.contents-by-type.call';
export const KEY_GET_NEW_CONTENTS = 'get.new-contents.call';
export const KEY_GET_MY_CONTENTS = 'get.my-contents.call';
export const KEY_GET_TAGS = 'get.tags-contents.call';
export const KEY_GET_CONTENT_DETAILS = 'get.content-details.call';
export const KEY_GET_CONTENTS_IN_PROGRESS = 'get.contents-in-progress.call';
export const KEY_GET_CONTENT_START = 'get.content-start.call';
export const KEY_POST_CONTENT_START = 'post.content-start.call';
export const KEY_POST_CONTENT_PROGRESS = 'post.content-progress.call';
export const KEY_POST_CONTENT_END = 'post.content-end.call';
